import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TInitStore } from '@monorepo/types';

export const selectInitStore = createFeatureSelector<TInitStore>('INIT_STORE');
export const getLockDetails = createSelector(selectInitStore, (initStore) => {
  return initStore.lockDetails;
});

export const getNextCacheResetTimestamp = createSelector(selectInitStore, (initStore) => {
  return initStore.nextCacheResetTimestampDB.nextCacheResetTimestamp;
});
